import { Belender } from '@pepper/belender-react';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';
import { useEffect } from 'react';
import TokenService from '../../services/Token';
import { useNavigate } from 'react-router-dom';
import { ROUTES_PATH } from '../../constants';
import { EnvType } from '../Tpv';
import { useCustomerClassification } from '../../contexts/CustomerClassificationContext';
import { useFingerprint } from '../../contexts/FingerprintContext';
import { AnalyticsEventType } from '../../interfaces/Analytics';
import AnalyticsService from '../../services/Analytics';
import AnalyticsHelper from '../../utils/analyticsHelper';
import dayjs from 'dayjs';

export enum EnvironmentType {
  development = 'development',
  staging = 'staging',
  production = 'production',
}

enum RedirectionStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  ERROR_CREATE = 'error_create',
}

interface PersonalFinancesProps {
  loadingEvent: (data: boolean) => void;
}
export const PersonalFinances: React.FC<PersonalFinancesProps> = ({
  loadingEvent,
}) => {
  let navigate = useNavigate();
  const { creditProposalResult } = useCreditProposalResult();
  const { customerClassification } = useCustomerClassification();
  const { fingerprint } = useFingerprint();
  const environment: EnvType = {
    type: import.meta.env.VITE_ENV,
  };

  const startTime = dayjs();
  let pinAttempts = 0;

  const handleStatus = (e: any) => {
    if (e === RedirectionStatus.SUCCESS) {
      AnalyticsService.continueBel({
        time_elapsed: AnalyticsHelper.getTimeElapse({ initTime: startTime, finishTime: dayjs() }),
        attemp_number: pinAttempts,
      })
      if (customerClassification?.require_documentation && !creditProposalResult.ocr_id) {
        navigate(ROUTES_PATH.OCR);
      } else {
        navigate(ROUTES_PATH.PAYMENT);
      }
    } else if (e === RedirectionStatus.ERROR_CREATE) {
      navigate(ROUTES_PATH.PERSONAL_FINANCES_UNAVAILABLE, {
        state: { errorType: 'ERR' },
      });
    } else if (e === RedirectionStatus.ERROR) {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };

  const getEnvironment = () => {
    switch (environment.type) {
      case 'development':
        return EnvironmentType.development;
      case 'staging':
        return EnvironmentType.staging;
      case 'production':
        return EnvironmentType.production;
      default:
        return EnvironmentType.development;
    }
  };

  const handleEvents = (eventText: string) => {
    switch (eventText) {
      case AnalyticsEventType.show_legal_bel:
        AnalyticsService.showLegalBel();
        break;
      case AnalyticsEventType.invalid_phone_bel:
        AnalyticsService.invalidPhoneBel();
        break;
      case AnalyticsEventType.retry_phone_bel:
        AnalyticsService.retryPhoneBel({
          time_elapsed: AnalyticsHelper.getTimeElapse({ initTime: startTime, finishTime: dayjs() }),
        });
        break;
      case AnalyticsEventType.resend_sms_bel:
        AnalyticsService.resendSmsBel({
          time_elapsed: AnalyticsHelper.getTimeElapse({ initTime: startTime, finishTime: dayjs() }),
        });
        break;
      case AnalyticsEventType.pin_error_bel:
        pinAttempts++;
        AnalyticsService.pinErrorBel({
          time_elapsed: AnalyticsHelper.getTimeElapse({ initTime: startTime, finishTime: dayjs() }),
          attemp_number: pinAttempts,
        });
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    loadingEvent(false);
  }, []);

  return (
    <>
      <Belender
        token={TokenService.getToken()!}
        creditProposalId={creditProposalResult!.credit_proposal_id}
        currentEnv={getEnvironment()}
        status={handleStatus}
        stepEvent={() => { }}
        
      />
    </>
  );
};
